import { Component, OnInit, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { TeacherSurvey } from '@ascschool/model/survey/teacher-survey';
import { SurveyPublicService } from '@ascschool/services/public/survey-public.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { element } from 'protractor';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-phieu-hoi-giao-vien',
  templateUrl: './phieu-hoi-giao-vien.component.html',
  styleUrls: ['./phieu-hoi-giao-vien.component.scss']
})
export class PhieuHoiGiaoVienComponent implements OnInit {
  @ViewChildren("label") labelElement;
  staffSurvey = new TeacherSurvey;
  inputCode: any = [];
  isCheckValidate = true;
  day: number;
  month: number;
  year: number
  yearNow = (new Date()).getFullYear();
  getMajorACFn: (value: any) => Observable<any>;
  MajorSubscription: any;
  MajorControl = new FormControl;

  getQualificationACFn: (value: any) => Observable<any>;
  QualificationSubscription: any;
  QualificationControl = new FormControl();

  listRequired  = [
    { name :'fullName', constraint: null},
    { name :'yearOfBirth', constraint: null},
    { name :'gender', constraint: null},
    { name :'folkId', constraint: null},
    { name :'staffUnfostered', constraint: null},
  ];
  getFolkACFn: (value: any) => Observable<any>;
  FolkSubscription: any;
  FolkControl = new FormControl();

  getEducationLevelACFn: (value: any) => Observable<any>;
  EducationLevelSubscription: any;
  EducationLevelControl = new FormControl();

  constructor(
    private msg: NzMessageService,
    private publicService: SurveyPublicService,
    public utilService: UtilsService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.loadFolk();
    setTimeout(() => {
      this.FolkControl.setValue({id: 1027, folkName: "Kinh"});
    }, 100);
    this.loadEducationLevel();
    this.getSkillTypes();
    this.getInformationSources();
    this.loadMajor();
    this.loadQualification();
    this.loadDiploma();
    this.getPublicTeachingAndSupport();
    this.getPublicParticipants();
    this.getPublicAdjustContents();
    this.getPublicFacilitiesAndEquipment();
    this.getPublicTrainingAndRetraining();
    this.getPublicParticipationMode();
    this.getPubliDifficultyInEducations();
    this.getPubliPublicTeachersDesires();
    this.getCoordination();
    /////////////////////////////////////////////////
    this.staffSurvey.gender = 1;
  }
  valueIfHas(control: FormControl) {
    if (control.value && typeof control.value != 'string') return control.value.id;
    return '';
  }
  loadFolk() {
    this.getFolkACFn = (value: any) => this.publicService.getPublicFolks({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.folkName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.FolkSubscription) this.FolkSubscription = this.FolkControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.staffSurvey, 'folkId', this.FolkControl.value);
    });
  }
  changeFolk(control: FormControl) {
    this.FolkControl = control;
  }
  loadEducationLevel() {
    this.getEducationLevelACFn = (value: any) => this.publicService.getPublicEducationLevels({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.name })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.EducationLevelSubscription) this.EducationLevelSubscription = this.EducationLevelControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.staffSurvey, 'educationLevelId', this.EducationLevelControl.value);
    });
  }
  changeEducationLevel(control: FormControl) {
    this.EducationLevelControl = control;
  }
  loadMajor() {
    this.getMajorACFn = (value: any) => this.publicService.getPublicMajor({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      // tslint:disable-next-line: max-line-length
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.majorName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.MajorSubscription) { this.MajorSubscription = this.MajorControl.valueChanges.subscribe(() => {
      this.utilService.bindOrUnBindTheId(this.staffSurvey, 'majorId', this.MajorControl.value);
    });
    }
  }
  changeMajor(control: FormControl) {
    this.MajorControl = control;
  }
  loadQualification() {
    // tslint:disable-next-line: max-line-length
    this.getQualificationACFn = (value: any) => this.publicService.getPublicQualification({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.qualificationName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.QualificationSubscription) {
      this.QualificationSubscription = this.QualificationControl.valueChanges.subscribe(() => {
        this.utilService.bindOrUnBindTheId(this.staffSurvey, 'qualificationId', this.QualificationControl.value);
      });
    }
  }
  changeQualification(control: FormControl) {
    this.QualificationControl = control;
  }
   //Get List/////////////////////////////
  listDiploma = [];
  loadDiploma() {
    // tslint:disable-next-line: max-line-length
    this.publicService.getPublicStaffCertificate({ PageIndex: 1, PageSize: 100 }).subscribe(element =>{
      this.listDiploma = element.results.map(x => ({ value: x.id, name: x.diplomaName, checked: false }));
    });
  }
  diplomaChange(event, index){
    this.listDiploma[index].checked = event;
  }

  staffUnfosteredlChange(event){
    this.staffSurvey.staffUnfostered = event;
    if(!event){
      this.listDiploma.forEach(element =>{
        element.checked = false;
      });
    }
  }
  listSkillTypes = [];
  getSkillTypes(){
    this.publicService.getPublicSkillTypes({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      this.listSkillTypes = res.results.map(x =>({skillTypeId: x.id, hasBeenTrained : false,isDemand: false, name: x.name}));
    });
  }
  listCoordination = [];
  getCoordination(){
    this.publicService.getPublicCaCoordinationAsfacs({ PageIndex: 1, PageSize: 100 }).subscribe(res => {

      this.listCoordination = res.results.map(x =>({id: x.id, name: x.name}));
    });
  }
  isCoordinationChange(event){
    this.staffSurvey.isCoordinationAsfac = event;
    if(!event){
      this.staffSurvey.coordinationAsfacId = null;
    }
  }
  listInformationSources = [];
  getInformationSources(){
    this.publicService.getPublicInformationSources({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listInformationSources = res.results.map(x => ({ value: x.id, name: x.name, checked: false, isRequiredNote: x.isRequiredNote }));
    });
  }
  changeOneCheckInformationSources(event, index){
    this.listInformationSources[index].checked = event;
    if(this.listInformationSources[index].isRequiredNote &&  !this.listInformationSources[index].checked){
      // this.staffSurvey.informationSourceNote = '';
    }
  }
  difficultyInEducationsChange(event, index){
    this.listDifficultyInEducations[index].checked = event;
    if(this.listDifficultyInEducations[index].isRequiredNote &&  !this.listDifficultyInEducations[index].checked){
      this.staffSurvey.difficultyInEducationOther = '';
    }
  }
  teachersDesiresChange(event, index){
    this.listPublicTeachersDesires[index].checked = event;
    if(this.listPublicTeachersDesires[index].isRequiredNote &&  !this.listPublicTeachersDesires[index].checked){
    }
  }


  // Nội dung điều chỉnh
  listAdjustContents = [];
  getPublicAdjustContents(){
    this.publicService.getPublicAdjustContents({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listAdjustContents = res.results.map(x => ({ value: x.id, name: x.name, checked: false, hasMade: null, levelBuild: 0, adjustContentId: x.id }));
    });
  }
  hasMadeACChange(event, index){
    this.listAdjustContents[index].hasMade = event;
    // if(!this.listAdjustContents[index].hasMade){
    //   this.listAdjustContents[index].levelBuild = 0;
    // }
  }
  // Phương tiên điều chỉnh
  listFacilitiesAndEquipment = [];
  getPublicFacilitiesAndEquipment(){
    this.publicService.getPublicDisFacilitiesAndEquipmentStaffs({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listFacilitiesAndEquipment = res.results.map(x => ({ value: x.id, name: x.name, checked: false, amountStatus: 0, quantityStatus: 0, facilitiesAndEquipmentId: x.id }));
    });
  }
  amountStatusFAEChange(event, index){
    this.listFacilitiesAndEquipment[index].amountStatus = event;
    // if(this.listFacilitiesAndEquipment[index].quantityStatus === 1){
    //   this.listFacilitiesAndEquipment[index].levelBuild = 0;
    // }
  }
  //hoạt động dạy học và hỗ trợ
  listTeachingAndSupport = [];
  getPublicTeachingAndSupport(){
    this.publicService.getPublicTeachingAndSupport({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listTeachingAndSupport = res.results.map(x => ({ value: x.id, name: x.name, checked: false, hasJoined: null, skillLevelId: 0, teachingAndSupportId: x.id }));
    });
  }
  hasJoinedTASChange(event, index){
    this.listTeachingAndSupport[index].hasJoined = event;
    // if(!event){
    //   this.listTeachingAndSupport[index].skillLevelId = 0;
    // }
  }
  //Người tham gia
  listParticipants = [];
  getPublicParticipants(){
    this.publicService.getPublicParticipants({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listParticipants = res.results.map(x => ({ value: x.id, name: x.name, checked: false, hasBuild: null, participantId: x.id, hasMade: null }));
    });
  }
  hasBuildParticipantsChange(event, index){
    this.listParticipants[index].hasBuild = event;
    // if(!event){
    //   this.listParticipants[index].hasMade = null;
    // }
  }
  //Người tham gia
  listTrainingAndRetraining = [];
  getPublicTrainingAndRetraining(){
    this.publicService.getPublicTrainingAndRetraining({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listTrainingAndRetraining = res.results.map(x => ({ value: x.id, name: x.name, checked: false, applied: null, trainingAndRetrainingId: x.id, hasJoined: null, resultsInApplied: 0 }));
    });
  }
  hasJoinedTARChange(event, index){
    this.listTrainingAndRetraining[index].hasJoined = event;
    // if(!event){
    //   this.listTrainingAndRetraining[index].applied = null;
    //   this.listTrainingAndRetraining[index].resultsInApplied = 0;
    // }
  }
  appliedTARChange(event, index){
    this.listTrainingAndRetraining[index].applied = event;
    // if(!event){
    //   this.listTrainingAndRetraining[index].resultsInApplied = 0;
    // }
  }
  //Chế độ
  listParticipationMode = [];
  getPublicParticipationMode(){
    this.publicService.getPublicParticipationMode({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listParticipationMode = res.results.map(x => ({ value: x.id, name: x.name, checked: false, applied: null, participationModeId: x.id, hasMade: null }));
    });
  }
    //Khó khăn
  listDifficultyInEducations = [];
  getPubliDifficultyInEducations(){
    this.publicService.getPublicDifficultyInEducations({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listDifficultyInEducations = res.results.map(x => ({ value: x.id, name: x.name, checked: false, difficultyInEducationId: x.id, isRequiredNote: x.isRequiredNote }));
    });
  }
    //Mong muốn
  listPublicTeachersDesires = [];
  getPubliPublicTeachersDesires(){
    this.publicService.getPublicTeachersDesires({ PageIndex: 1, PageSize: 100 }).subscribe(res => {
      res.results.sort(function(a, b){return a.displayOrder - b.displayOrder});
      this.listPublicTeachersDesires = res.results.map(x => ({ value: x.id, name: x.name, checked: false, teachersDesiresId: x.id, isRequiredNote: x.isRequiredNote }));
    });
  }

  ///Update/////////////////////////////////////////////
  update(){
    this.pasteArr();
    if(this.checkValid(this.staffSurvey, this.listRequired, this.labelElement)){
      this.publicService.AddStaffSurvey(this.staffSurvey).subscribe((res) => {
        if (res.statusCode === 0){
          this.msg.success('Thành công');
          this.router.navigate(['/camOnKhaoSat',2]);
        }else{
          this.msg.warning(res.message);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      });
    }
  }
  pasteArr(){
    this.staffSurvey.staffSurveyCertificates = [];
    this.staffSurvey.staffSurveyTeachingAndSupports = [];
    this.staffSurvey.staffSurveyParticipants = [];
    this.staffSurvey.staffSurveyAdjustContents = [];
    this.staffSurvey.staffSurveyFacilitiesAndEquipments = [];
    this.staffSurvey.staffSurveyTrainingAndRetraining = [];
    this.staffSurvey.staffSurveyParticipationModes = [];
    this.staffSurvey.staffSurveyDifficultyInEducations = [];
    this.staffSurvey.staffSurveyTeachersDesires = [];
    this.listDiploma.forEach(element =>{
      if(element.checked){
        this.staffSurvey.staffSurveyCertificates.push(element.value);
      }
    });
    this.listTeachingAndSupport.forEach(element =>{
      if(element.hasJoined !== null || element.skillLevelId !== 0){
        this.staffSurvey.staffSurveyTeachingAndSupports.push({hasJoined: element.hasJoined, skillLevelId : element.skillLevelId, teachingAndSupportId: element.teachingAndSupportId})
      }
    });
    this.listParticipants.forEach(element =>{
      if(element.hasBuild !== null || element.hasMade !== null){
        this.staffSurvey.staffSurveyParticipants.push({hasBuild: element.hasBuild, hasMade : element.hasMade === null ? false : element.hasMade,participantId: element.participantId});
      }
    });
    this.listAdjustContents.forEach(element =>{
      if(element.hasMade !== null || element.levelBuild !== 0){
        this.staffSurvey.staffSurveyAdjustContents.push({levelBuild: element.levelBuild, hasMade : element.hasMade, adjustContentId: element.adjustContentId});
      }
    });
    this.listFacilitiesAndEquipment.forEach(element =>{
      if(element.amountStatus !== 0 || element.quantityStatus !== 0){
        this.staffSurvey.staffSurveyFacilitiesAndEquipments.push({amountStatus: element.amountStatus, quantityStatus : element.quantityStatus, facilitiesAndEquipmentId: element.facilitiesAndEquipmentId});
      }
    });
    this.listTrainingAndRetraining.forEach(element =>{
      if(element.hasJoined !== null || element.applied !== null || element.resultsInApplied !== 0){
        this.staffSurvey.staffSurveyTrainingAndRetraining.push({hasJoined: element.hasJoined, applied : element.applied ? element.applied : false, trainingAndRetrainingId: element.trainingAndRetrainingId, resultsInApplied: element.resultsInApplied});
      }
    });
    this.listParticipationMode.forEach(element =>{
      if(element.hasMade !==null){
        this.staffSurvey.staffSurveyParticipationModes.push({hasMade: element.hasMade, participationModeId: element.participationModeId});
      }
    });
    this.listDifficultyInEducations.forEach(element =>{
      if(element.checked){
        this.staffSurvey.staffSurveyDifficultyInEducations.push(element.value);
      }
    });
    this.listPublicTeachersDesires.forEach(element =>{
      if(element.checked){
        this.staffSurvey.staffSurveyTeachersDesires.push(element.value);
      }
    });
  }
  checkValid(data, listRequired, labelElement){
    let count = 0;
    let keyError = [];
    listRequired.forEach(
      element =>{
        let key = element.name;
        let constraint = element.constraint;
        if((typeof(data[key]) !== 'undefined') && (data[key] !== null)){
        }else{
          count++;
          keyError.push(key);
        }
        if(constraint){
          if(Array.isArray(data[key]) && data[key].length === 0){
            if(data[constraint]){
              count++;
              keyError.push(key);
            }
          }
        }else{
          if(Array.isArray(data[key]) && data[key].length === 0){
            count++;
            keyError.push(key);
          }
        }
    });
    if(count > 0){
      this.utilService.notifyValidateSurvey(keyError,labelElement);
      return false;
    }else{
      return true;
    }
  }
}
